// extracted by mini-css-extract-plugin
module.exports = {"root":"ClearentDisclaimer_root__1gOV_","header":"ClearentDisclaimer_header__2MGn4","inner":"ClearentDisclaimer_inner__s3EUk"};